module.exports = __webpack_public_path__ + "static/media/p-logo-taishin.835700f3.svg";